const mockedDate: { current: number | undefined } = { current: undefined }

const currentDateMs = (): number => mockedDate.current ?? Date.now()

export const setMockedDate = (timestamp: number | undefined) => {
  mockedDate.current = timestamp
}

export default currentDateMs
